export default __webpack_public_path__ + "static/media/average_inbound_duration.702d3546.svg";